@if (control?.invalid && (control?.dirty || control?.touched)) {
  <div
    class="validator-msg"
    [ngClass]="{ 'validator-msg--error': isError() && control?.invalid && (control?.dirty || control?.touched) }"
    [style]="customStyle()"
  >
    @if (control.errors?.required) {
      <div>{{ requiredMessage() }}</div>
    }
    @if (control.errors?.email) {
      <div>Invalid email address.</div>
    }
    @if (control.errors?.min || control.errors?.max) {
      <div>{{ requiredMessage() }}</div>
    }
    @if (control.errors?.cmgValidationError) {
      <div class="d-flex align-items-center">
        @if (icon) {
          <i class="me-2 fs-4 {{ icon }}"></i>
        }
        {{ control.errors?.cmgValidationError }}
      </div>
    }
  </div>
}
